import { render, staticRenderFns } from "./dosis.vue?vue&type=template&id=6b55b240"
import script from "./dosis.vue?vue&type=script&lang=js"
export * from "./dosis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports